import CustomSVG, { customSVGPropTypes } from './CustomSVG'

export { customSVGPropTypes }
export default CustomSVG
